import "./MobileControls.css";
import { useSelector, useDispatch } from "react-redux";
import {
  setReady,
  setScore,
  setPause,
} from "../../../config/redux/engineSlice";
import { marioJumping } from "../../../config/redux/marioSlice";
import { useMemo } from "react";
import jumpAudio from "../../../assets/audio/mario-jump.mp3";

const MobileControls = () => {
  const isPlay = useSelector((state) => state.engine.play);
  const isDie = useSelector((state) => state.engine.die);
  const isPaused = useSelector((state) => state.engine.pause);
  const isJumping = useSelector((state) => state.mario.jumping);
  const dispatch = useDispatch();

  const jump = useMemo(() => new Audio(jumpAudio), []);

  const handleScreenTouch = () => {
    if (!isPlay && !isDie) {
      dispatch(setScore(0));
      dispatch(setReady(true));
      dispatch(setPause(false));
    } else if (isPlay && !isDie && !isPaused && !isJumping) {
      dispatch(marioJumping(true));
      jump.play();
      setTimeout(() => {
        dispatch(marioJumping(false));
        jump.pause();
        jump.currentTime = 0;
      }, 400);
    }
  };

  return (
    <>
      {/* Full-screen touch listener - only show when not in game over state */}
      {!isDie && (
        <div
          className="touch-area"
          onTouchStart={handleScreenTouch}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 1,
            pointerEvents: "fill",
          }}
        />
      )}

      {/* Centered GAME OVER text */}
      {isDie && !isPlay && <div className="game-over-text">GAME OVER</div>}
    </>
  );
};

export default MobileControls;
